import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeclineAttentionPopup = _resolveComponent("DeclineAttentionPopup")!
  const _component_DeclinePopup = _resolveComponent("DeclinePopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isShowAttentionDecline)
      ? (_openBlock(), _createBlock(_component_DeclineAttentionPopup, {
          key: 0,
          onConfirmDecline: _ctx.confirmAttentionDecline,
          onClose: _ctx.closeDecline
        }, null, 8, ["onConfirmDecline", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDecline)
      ? (_openBlock(), _createBlock(_component_DeclinePopup, {
          key: 1,
          onConfirmDecline: _ctx.confirmDecline,
          onClose: _ctx.closeDecline
        }, null, 8, ["onConfirmDecline", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}